import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { tss } from 'tss-react';

import {
	getIcon,
	getPriorityColor,
} from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/ProductTableItem';

interface IProps {
	togglePriority: (priority: number) => void;
	priority: number | undefined;
	flexDirection?: 'row' | 'column';
}

const PrioritySelect = (props: IProps) => {
	const { classes } = useStyles();
	return (
		<div
			className={classes.prioritySelect}
			style={{ flexDirection: props.flexDirection ?? 'row' }}
		>
			{[1, 2, 3].map((e) => {
				return (
					<FontAwesomeIcon
						key={e}
						title={'Priority ' + e}
						size={'lg'}
						style={{ color: getPriorityColor(e) }}
						className={props.priority === e ? classes.active : classes.inactive}
						icon={getIcon(e)}
						onClick={() => {
							props.togglePriority(e);
						}}
					/>
				);
			})}
		</div>
	);
};

export default PrioritySelect;

export const useStyles = tss.create({
	prioritySelect: {
		display: 'flex',
		cursor: 'pointer',
		gap: '3px',
	},
	active: {
		opacity: 1,
		filter: 'grayscale(0)',
	},
	inactive: {
		opacity: 0.3,
		filter: 'grayscale(1)',
		'&:hover': {
			opacity: 1,
			filter: 'grayscale(0)',
		},
	},
});
